module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-76x76.f1e3555b2f82212610c6852a88b4d922.png";